import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useQuestionAnswerSearchDispatch, useQuestionAnswerSearchState } from './question-answer-search-context';
import QuestionAnswerAppService from '../../../../application/platform/apm/question-answer/question-answer-app-service';
import { IQuestionAnswerResponse } from '../../../../model/apm/question-answer/response/question-answer-response';
import { IQuestionAnswerAddEditRequest } from '../../../../model/apm/question-answer/request/question-answer-add-edit-request';
import { IQuestionAnswerPagedRequest } from '../../../../model/apm/question-answer/request/question-answer-paged-request';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { useSearchActions } from '../../../../hooks/use-search-actions';
import { parseIdFilter } from '../../../../utils/filter-options';

export const useQuestionAnswerSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useQuestionAnswerSearchDispatch();
    const state = useQuestionAnswerSearchState();
    const { isSaving, runSaving, run, showSuccess, confirmDelete } = useActionRunner();
    const { updateParameters, triggerSearch, ...searchHandlers } = useSearchActions<IQuestionAnswerPagedRequest>(
        dispatch, ACTION_TYPES, { term: undefined, categoryId: undefined },
    );

    useEffect(() => {
        run('Não foi possível carregar as categorias', async () => {
            dispatch({ type: ACTION_TYPES.setCategories, payload: await QuestionAnswerAppService.listCategories() });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-term') updateParameters({ term: value || undefined });
        if (name === 'select-category') updateParameters({ categoryId: parseIdFilter(value) });
    }

    // A listagem já traz a pergunta completa
    function openDrawer(row?: IQuestionAnswerResponse) {
        dispatch({ type: ACTION_TYPES.openDrawer, payload: row });
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    function handleSave(request: IQuestionAnswerAddEditRequest) {
        const editing = state.drawer.questionAnswer;
        return runSaving('Não foi possível salvar a pergunta', async () => {
            await (editing ? QuestionAnswerAppService.edit(editing.id, request) : QuestionAnswerAppService.add(request));
            showSuccess(editing ? 'Pergunta atualizada com sucesso!' : 'Pergunta cadastrada com sucesso!');
            closeDrawer();
            triggerSearch();
        });
    }

    function handleDelete(row: IQuestionAnswerResponse) {
        confirmDelete(`Tem certeza que deseja excluir a pergunta "${row.question}"?`, () => run('Não foi possível excluir a pergunta', async () => {
            await QuestionAnswerAppService.remove(row.id);
            showSuccess('Pergunta excluída com sucesso!');
            triggerSearch();
        }));
    }

    function navigateToCategories() {
        navigate('/perguntas-respostas/categorias');
    }

    return {
        isSaving,
        handleOnChange, ...searchHandlers,
        openDrawer, closeDrawer, handleSave, handleDelete, navigateToCategories,
    };
};
